import dispatcher from "../Dispatcher/Dispatcher";
import { EventEmitter } from "events";
import PublicWebsiteConstants from "../Constants/PublicWebsiteConstants";

let resultValue = null;
let equipPublicInfoResult = null;
let downloadDocResult = null;
let createTicketResult = null;
let titleResult = null;
let descriptionResult = null;
let equipGrpConfigRes = null;
class PublicWebsiteStore extends EventEmitter {
  emitChange(eventName) {
    this.emit(eventName);
  }

  getResult() {
    return resultValue;
  }

  setResult(result) {
    resultValue = result;
  }

  getEquipPublicInfoResult() {
    return equipPublicInfoResult;
  }

  setEquipPublicInfoResult(result) {
    equipPublicInfoResult = result;
  }

  getDownloadDocResult() {
    return downloadDocResult;
  }

  setDownloadDocResult(result) {
    downloadDocResult = result;
  }

  getCreateTicketResult() {
    return createTicketResult;
  }

  setCreateTicketResult(result) {
    createTicketResult = result;
  }

  getTitleResult() {
    return titleResult;
  }

  setTitleResult(result) {
    titleResult = result;
  }

  getDescriptionResult() {
    return descriptionResult;
  }

  setDescriptionResult(result) {
    descriptionResult = result;
  }

  getEquipGrpConfResult() {
    return descriptionResult;
  }

  setEquipGrpConfResult(result) {
    equipGrpConfigRes = result;
  }

  addChangeListener(eventName, callback) {
    this.on(eventName, callback);
  }

  removeChangeListener(eventName, callback) {
    this.removeListener(eventName, callback);
  }
  handleCallback(action) {
    switch (action.type) {
      case PublicWebsiteConstants.GET_CONFIGURATION_OPTION_SUCCESS:
        this.setResult(action.result);
        break;
      case PublicWebsiteConstants.GET_CONFIGURATION_OPTION_FAILURE:
        this.setResult(action.result);
        break;
      case PublicWebsiteConstants.SAVE_UPDATE_CONFIGURATION_OPTION_SUCCESS:
        this.setResult(action.result);
        break;
      case PublicWebsiteConstants.SAVE_UPDATE_CONFIGURATION_OPTION_FAILURE:
        this.setResult(action.result);
        break;
      case PublicWebsiteConstants.GET_EQUIPMENT_PUBLIC_INFO_SUCCESS:
        this.setEquipPublicInfoResult(action.result);
        break;
      case PublicWebsiteConstants.GET_EQUIPMENT_PUBLIC_INFO_FAILURE:
        this.setEquipPublicInfoResult(action.result);
        break;
      case PublicWebsiteConstants.DOWNLOAD_DOC_SUCCESS:
        this.setDownloadDocResult(action.result);
        break;
      case PublicWebsiteConstants.DOWNLOAD_DOC_FAILURE:
        this.setDownloadDocResult(action.result);
        break;
      case PublicWebsiteConstants.CREATE_TICKET_SUCCESS:
        this.setCreateTicketResult(action.result);
        break;
      case PublicWebsiteConstants.CREATE_TICKET_FAILURE:
        this.setCreateTicketResult(action.result);
        break;
      case PublicWebsiteConstants.GET_TITLE_SUCCESS:
        this.setTitleResult(action.result);
        break;
      case PublicWebsiteConstants.GET_TITLE_FAILURE:
        this.setTitleResult(action.result);
        break;
      case PublicWebsiteConstants.GET_TITLE_DESCRIPTION_SUCCESS:
        this.setDescriptionResult(action.result);
        break;
      case PublicWebsiteConstants.GET_TITLE_DESCRIPTION_FAILURE:
        this.setDescriptionResult(action.result);
        break;
      case PublicWebsiteConstants.GET_EQUIP_GRP_CONF_SUCCESS:
        this.setDescriptionResult(action.result);
        break;
      case PublicWebsiteConstants.GET_EQUIP_GRP_CONF_FAILURE:
        this.setDescriptionResult(action.result);
        break;
      default:
        break;
    }
    this.emitChange(action.type);
    return true;
  }
}
const publicWebsiteStore = new PublicWebsiteStore();
dispatcher.register(publicWebsiteStore.handleCallback.bind(publicWebsiteStore));
export default publicWebsiteStore;
